import { render, staticRenderFns } from "./return-case-pool.vue?vue&type=template&id=b13c3ede&scoped=true"
import script from "./return-case-pool.vue?vue&type=script&lang=ts"
export * from "./return-case-pool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13c3ede",
  null
  
)

export default component.exports